'use strict'

export default (mockAxios) => {
  // データの保存期間を取得
  mockAxios.onGet(`/expiresettings`).reply(200, {
    'success': true,
    'data': {
      'save_image_entry': 0,
      'save_import_log': 0,
      'save_access_log': 0
    }
  })

  mockAxios.onPut(`/expiresettings`).reply(200, {
    'success': true,
    'data': {
      'save_image_entry': 0,
      'save_import_log': 0,
      'save_access_log': 0
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/expireSettingRepositoryMock.js